import PropTypes from "prop-types";
import React, { Component } from "react";
import {Helmet} from 'react-helmet'

class PageHelmetApple extends Component{
    render(){
        return(
            <React.Fragment>
                <Helmet>
                    <meta charSet="utf-8" />
                    <title>{this.props.pageTitle} - Na Plugify alugar é melhor que comprar </title>
                    <meta name="robots" content="follow" />
                    {/* <meta name="description" content="Plugify - Destrave o crescimento da sua empresa - Simplifique sua TI" /> */}
                    <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
                    <link rel="canonical" href="https://www.plugify.com.br/alugueapple" />
                    <meta name="description" content="A Plugify é um Apple Authorized Corporate Reseller e tem acesso às melhores ofertas e às mais recentes inovações que a Apple traz para o mundo corporativo" />
                    <meta name="twitter:card" content="summary_large_image" />
                    <meta name="twitter:site" content="@user" /> 
                    <meta name="twitter:creator" content="@user" />
                    <meta name="twitter:title" content="Plugify - Alugar é melhor que comprar" />
                    <meta name="twitter:description" content="Mais eficiência e praticidade na gestão do seu parque com locação de equipamentos Apple" />
                    <meta name="twitter:image" content="url_to_image"/>
                    <meta property="og:title" content="Plugify - Alugar é melhor que comprar" />
                    <meta property="og:description" content="Mais eficiência e praticidade na gestão do seu parque com locação de equipamentos Apple" />
                    <meta property="og:image" content="url_to_image"/>
                    <meta property="og:url" content="Mais eficiência e praticidade na gestão do seu parque com locação de equipamentos Apple" />
                    <meta property="og:site_name" content="Plugify - Alugar é melhor que comprar" />
                    <meta property="og:locale" content="pt_BR" />
                    <meta property="og:type" content="article" />
                    <meta property="fb:app_id" content="ID_APP_FACEBOOK" />


                </Helmet>
            </React.Fragment>
        )
    }
}
PageHelmetApple.propTypes = {
    title: PropTypes.string
};
export default PageHelmetApple;
